// Layout principale: header sticky + content scorrevole + bottom nav
import type { ReactNode } from 'react';
import { BottomNav } from './BottomNav';

interface LayoutProps {
  children: ReactNode;
  /** Se true usa il layout "kanban" (header sticky + content full-height scroll orizzontale) */
  kanban?: boolean;
}

export function Layout({ children, kanban }: LayoutProps) {
  if (kanban) {
    // Layout per Kanban: header sticky, poi area scroll orizzontale
    return (
      <div className="h-screen flex flex-col bg-slate-50 dark:bg-slate-950 overflow-hidden">
        <div className="flex-1 overflow-hidden flex flex-col min-h-0">{children}</div>
        <BottomNav />
      </div>
    );
  }
  // Layout standard: header sticky + content scroll verticale
  return (
    <div className="h-screen flex flex-col bg-slate-50 dark:bg-slate-950 overflow-hidden">
      <div className="flex-1 overflow-y-auto overflow-x-hidden -webkit-overflow-scrolling-touch">
        {children}
      </div>
      <BottomNav />
    </div>
  );
}

export function PageContainer({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={`px-4 py-4 ${className ?? ''}`}>{children}</div>;
}

/** Per le pagine Kanban: usa flex-1 + overflow */
export function KanbanPageContainer({ children, className }: { children: ReactNode; className?: string }) {
  return <div className={`flex-1 overflow-hidden flex flex-col min-h-0 ${className ?? ''}`}>{children}</div>;
}
